<template>
  <el-dialog
    :title="$t('deleteIntegral.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center">
      <p>{{ $t('deleteIntegral.confirmDeletePointsAccount') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteIntegral.cancel') }}</el-button>
      <el-button type="primary" @click="deleteIntegral">{{ $t('deleteIntegral.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteIntegral } from '@/api/admin/integralApi'

export default {
  name: 'DeleteIntegral',
  data() {
    return {
      dialogVisible: false,
      deleteIntegralInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteIntegralInfo = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteIntegralInfo = {}
    },
    async deleteIntegral() {
      try {
        await deleteIntegral(this.deleteIntegralInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('deleteIntegral.deleteSuccess'))
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>